import { useState } from 'react';
import ExcelJS from 'exceljs';
import { TOKENS } from '../tokens';
import { useThemedTokens } from "../theme";

const FH = TOKENS.fontHeading;
const FU = TOKENS.fontUI;

const TABLE_OPTIONS = [
  { value: 'active-grants',     label: 'Active Grants' },
  { value: 'pipeline-apps',     label: 'Applications (Pipeline)' },
  { value: 'completed-grants',  label: 'Completed Grants' },
  { value: 'terminated-grants', label: 'Terminated Grants' },
];

const FIELD_DEFS = {
  'active-grants': [
    { key: 'donor',       label: 'Funder/Donor',  alts: ['donor','funder','organization','grantor','sponsor','funding organization'] },
    { key: 'title',       label: 'Title',          alts: ['title','grant title','project title','project name','project','name'] },
    { key: 'grantNumber', label: 'Grant Number',   alts: ['grant number','grant no','award number','award no','grant #','award #','grant id'] },
    { key: 'pi',          label: 'PI',             alts: ['pi','principal investigator','lead pi','lead investigator'] },
    { key: 'start',       label: 'Start Date',     alts: ['start','start date','begin date','period start','project start'] },
    { key: 'end',         label: 'End Date',       alts: ['end','end date','expiry','period end','expiration','project end'] },
    { key: 'totalUSD',    label: 'Total Amount',   alts: ['total','total usd','total amount','funded amount','amount','budget','award amount','total award'] },
    { key: 'fy26',        label: 'FY26',           alts: ['fy26','fy 26','fiscal year 26','fy2026','fy 2026'] },
    { key: 'primeOrSub',  label: 'Prime/Sub',      alts: ['prime or sub','prime/sub','type','award type'] },
    { key: 'poc1',        label: 'POC 1',          alts: ['poc','poc1','contact','point of contact','poc 1','primary contact'] },
    { key: 'poc2',        label: 'POC 2',          alts: ['poc2','poc 2','secondary contact'] },
    { key: 'states',      label: 'States',         alts: ['states','state','location','region'] },
    { key: 'shortTitle',  label: 'Short Title',    alts: ['short title','short name','abbreviation','short'] },
    { key: 'brief',       label: 'Notes',          alts: ['notes','brief','description','remarks','comment','comments'] },
  ],
  'pipeline-apps': [
    { key: 'funder',        label: 'Funder',           alts: ['funder','organization','sponsor','grantor','donor','funding organization'] },
    { key: 'title',         label: 'Title',            alts: ['title','application','project','grant name','name','project title','opportunity title'] },
    { key: 'amount',        label: 'Amount',           alts: ['amount','funding','award','award amount','budget','requested amount','amount requested'] },
    { key: 'rfaNumber',     label: 'Opportunity #',    alts: ['rfa','rfa number','rfa #','opportunity id','opportunity number','grant id','notice number','foa'] },
    { key: 'deadline',      label: 'Deadline',         alts: ['deadline','due date','submission deadline','close date','closing date','application deadline'] },
    { key: 'submittedDate', label: 'Submitted Date',   alts: ['submitted date','submission date','date submitted','submitted'] },
    { key: 'status',        label: 'Status',           alts: ['status','application status','submission status'] },
    { key: 'awardStatus',   label: 'Award Status',     alts: ['award status','award','outcome','result'] },
    { key: 'primeOrSub',    label: 'Prime/Sub',        alts: ['prime or sub','prime/sub','type'] },
    { key: 'pi',            label: 'PI',               alts: ['pi','principal investigator','lead pi'] },
    { key: 'poc',           label: 'POC',              alts: ['poc','contact','point of contact','program officer'] },
    { key: 'remark',        label: 'Notes',            alts: ['notes','remark','remarks','description','comment','comments'] },
  ],
  'completed-grants': [
    { key: 'funder',        label: 'Funder',          alts: ['funder','organization','donor','grantor','sponsor','funding organization'] },
    { key: 'title',         label: 'Title',           alts: ['title','project','grant title','project title','name'] },
    { key: 'awardNumber',   label: 'Award Number',    alts: ['award number','award no','grant number','grant no','award #','grant id'] },
    { key: 'pi',            label: 'PI',              alts: ['pi','principal investigator','lead pi'] },
    { key: 'awardedAmount', label: 'Awarded Amount',  alts: ['awarded amount','amount','total','funding','award amount','funded amount','total award','total usd'] },
    { key: 'duration',      label: 'Duration',        alts: ['duration','period','length','project period'] },
    { key: 'year',          label: 'Year/Period',     alts: ['year','period of performance','pop','fiscal year'] },
    { key: 'primeOrSub',    label: 'Prime/Sub',       alts: ['prime or sub','prime/sub','type'] },
    { key: 'poc1',          label: 'POC 1',           alts: ['poc','poc1','contact','point of contact','poc 1','primary contact'] },
    { key: 'poc2',          label: 'POC 2',           alts: ['poc2','poc 2','secondary contact'] },
  ],
  'terminated-grants': [
    { key: 'funder',        label: 'Funder',          alts: ['funder','organization','donor','grantor','sponsor','funding organization'] },
    { key: 'title',         label: 'Title',           alts: ['title','project','grant title','project title','name'] },
    { key: 'awardNumber',   label: 'Award Number',    alts: ['award number','award no','grant number','grant no','award #','grant id'] },
    { key: 'pi',            label: 'PI',              alts: ['pi','principal investigator','lead pi'] },
    { key: 'awardedAmount', label: 'Awarded Amount',  alts: ['awarded amount','amount','total','funding','award amount','funded amount','total award','total usd'] },
    { key: 'duration',      label: 'Duration',        alts: ['duration','period','length','project period'] },
    { key: 'year',          label: 'Year/Period',     alts: ['year','period of performance','pop','fiscal year'] },
    { key: 'primeOrSub',    label: 'Prime/Sub',       alts: ['prime or sub','prime/sub','type'] },
    { key: 'poc1',          label: 'POC 1',           alts: ['poc','poc1','contact','point of contact','poc 1','primary contact'] },
    { key: 'poc2',          label: 'POC 2',           alts: ['poc2','poc 2','secondary contact'] },
    { key: 'remarks',       label: 'Remarks',         alts: ['remarks','notes','remark','description','reason','termination reason'] },
  ],
};

function autoMap(fileHeaders, defs) {
  const normalized = fileHeaders.map(h => ({ orig: h, norm: h.toLowerCase().trim() }));
  const result = {};
  for (const def of defs) {
    for (const alt of def.alts) {
      const match = normalized.find(h => h.norm === alt.toLowerCase());
      if (match) { result[def.key] = match.orig; break; }
    }
  }
  return result;
}

// An ExcelJS cell is a union type — primitive, Date, formula object, rich
// text, hyperlink or error. Flatten every shape to a string so the mapping
// code below never has to branch on it.
function cellToText(v) {
  if (v == null) return '';
  if (v instanceof Date) return v.toISOString().split('T')[0];
  if (typeof v === 'object') {
    if (Array.isArray(v.richText)) return v.richText.map(t => t.text || '').join('');
    if ('result' in v)  return cellToText(v.result);   // formula — cached value
    if ('text' in v)    return String(v.text);         // hyperlink
    return '';                                          // error / uncached formula
  }
  return String(v);
}

function parseCsv(text) {
  const rows = [];
  let row = [], field = '', quoted = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (quoted) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i++; }   // escaped quote
        else quoted = false;
      } else field += c;
    } else if (c === '"') quoted = true;
    else if (c === ',') { row.push(field); field = ''; }
    else if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; }
    else if (c !== '\r') field += c;
  }
  if (field !== '' || row.length) { row.push(field); rows.push(row); }
  return rows.filter(r => r.some(v => String(v).trim() !== ''));
}

async function parseFile(file) {
  // Replaced SheetJS (`xlsx`) with ExcelJS: SheetJS has two high-severity
  // advisories and no available fix. ExcelJS reads .xlsx only, so legacy
  // .xls now gets a clear message instead of a vulnerable parse.
  if (/\.xls$/i.test(file.name || '')) {
    throw new Error('This is a legacy .xls file. Open it in Excel and use Save As → Excel Workbook (.xlsx), then try again.');
  }
  // CSV: SheetJS used to handle this too, so it needs its own path now.
  // Small hand-rolled reader — handles quoted fields, escaped quotes and
  // both line endings, which is all a spreadsheet export produces.
  if (/\.csv$/i.test(file.name || '')) {
    const rows = parseCsv(await file.text());
    if (rows.length < 2) throw new Error('File must have a header row and at least one data row.');
    return buildRows(rows);
  }

  const buffer = await file.arrayBuffer();
  const wb = new ExcelJS.Workbook();
  await wb.xlsx.load(buffer);
  const ws = wb.worksheets[0];
  if (!ws) throw new Error('That workbook has no sheets.');
  const raw = [];
  ws.eachRow({ includeEmpty: true }, row => {
    raw.push((row.values || []).slice(1).map(cellToText)); // values is 1-indexed
  });
  if (raw.length < 2) throw new Error('File must have a header row and at least one data row.');
  return buildRows(raw);
}

// Shared by both the CSV and the .xlsx paths: first row is the header,
// the rest become objects keyed by it. Fully blank rows are dropped.
function buildRows(raw) {
  const headers = raw[0].map(h => String(h).trim()).filter(Boolean);
  const rows = raw.slice(1)
    .map(row => {
      const obj = {};
      headers.forEach((h, i) => { obj[h] = String(row[i] ?? '').trim(); });
      return obj;
    })
    .filter(r => Object.values(r).some(v => v));
  return { headers, rows };
}

export default function ImportModal({ defaultTable = 'pipeline-apps', onClose, onImport }) {
  const TOKENS = useThemedTokens(); // colours follow light/dark mode
  const [targetTable, setTargetTable] = useState(defaultTable);
  const [parsed,      setParsed]      = useState(null);
  const [colMap,      setColMap]      = useState({});
  const [error,       setError]       = useState('');
  const [loading,     setLoading]     = useState(false);

  const defs         = FIELD_DEFS[targetTable] || [];
  const mappedCount  = Object.keys(colMap).length;
  const canImport    = parsed && parsed.rows.length > 0 && mappedCount > 0;

  const handleTableChange = (val) => {
    setTargetTable(val);
    if (parsed) setColMap(autoMap(parsed.headers, FIELD_DEFS[val] || []));
  };

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setError(''); setLoading(true);
    try {
      const result = await parseFile(file);
      setParsed(result);
      setColMap(autoMap(result.headers, FIELD_DEFS[targetTable] || []));
    } catch (err) {
      setError(err.message || 'Could not parse file. Ensure row 1 contains column headers.');
      setParsed(null);
    } finally {
      setLoading(false);
    }
  };

  const doImport = () => {
    if (!canImport) return;
    const idPfx = { 'active-grants': 'ag', 'pipeline-apps': 'ap', 'completed-grants': 'cg', 'terminated-grants': 'tg' };
    const pfx   = idPfx[targetTable] || 'r';
    const records = parsed.rows.map(row => {
      const rec = { id: `${pfx}-${Math.random().toString(36).slice(2, 10)}`, sn: 0 };
      for (const def of defs) {
        const hdr  = colMap[def.key];
        rec[def.key] = hdr ? (row[hdr] || '') : '';
      }
      if (targetTable === 'pipeline-apps') {
        if (!rec.status)      rec.status      = 'Not Submitted';
        if (!rec.awardStatus) rec.awardStatus = 'Pending';
        if (!rec.primeOrSub)  rec.primeOrSub  = 'Prime';
      }
      return rec;
    });
    onImport(targetTable, records);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: TOKENS.bgCard, borderRadius: 12, border: `1px solid ${TOKENS.border}`, width: '100%', maxWidth: 820, maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 24px 48px rgba(0,0,0,0.6)' }}>

        {/* Header */}
        <div style={{ padding: '16px 20px', borderBottom: `1px solid ${TOKENS.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 600, color: TOKENS.textPrimary, fontFamily: FH }}>Import from CSV / Excel</div>
            <div style={{ fontSize: 12, color: TOKENS.textMuted, marginTop: 2, fontFamily: FU }}>Upload a .csv, .xlsx or .xls file — first row must be column headers.</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: TOKENS.textMuted, cursor: 'pointer', fontSize: 22, lineHeight: 1, padding: 4 }}>×</button>
        </div>

        {/* Body */}
        <div style={{ flex: 1, overflowY: 'auto', padding: 20 }}>

          {/* Controls */}
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 20, alignItems: 'flex-end' }}>
            <div style={{ flex: 1, minWidth: 180 }}>
              <div style={{ fontSize: 11, color: TOKENS.textMuted, fontFamily: FU, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 600 }}>Import into</div>
              <select
                value={targetTable}
                onChange={e => handleTableChange(e.target.value)}
                style={{ width: '100%', padding: '8px 10px', background: TOKENS.bgElevated, border: `1px solid ${TOKENS.border}`, borderRadius: 6, color: TOKENS.textPrimary, fontSize: 13, outline: 'none', fontFamily: FU }}
              >
                {TABLE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>
            <div style={{ flex: 2, minWidth: 220 }}>
              <div style={{ fontSize: 11, color: TOKENS.textMuted, fontFamily: FU, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 600 }}>File</div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px', background: TOKENS.bgElevated, border: `1px dashed ${TOKENS.border}`, borderRadius: 6, cursor: 'pointer', color: TOKENS.textMuted, fontSize: 13, fontFamily: FU }}>
                <span style={{ fontSize: 16 }}>📂</span>
                <span>{loading ? 'Reading…' : 'Choose CSV or Excel file'}</span>
                <input type="file" accept=".csv,.xlsx,.xls" onChange={handleFile} style={{ display: 'none' }} />
              </label>
            </div>
          </div>

          {error && (
            <div style={{ padding: '10px 12px', background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.4)', borderRadius: 8, color: '#ef4444', fontSize: 12, marginBottom: 14, fontFamily: FU }}>
              ⚠ {error}
            </div>
          )}

          {parsed ? (
            <>
              {/* Summary badges */}
              <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap', alignItems: 'center' }}>
                <span style={{ padding: '3px 10px', borderRadius: 20, background: 'rgba(16,185,129,0.12)', color: '#10b981', border: '1px solid rgba(16,185,129,0.3)', fontSize: 12, fontFamily: FU }}>
                  {parsed.rows.length} rows detected
                </span>
                <span style={{ padding: '3px 10px', borderRadius: 20, background: 'rgba(74,111,165,0.12)', color: TOKENS.slateBlue, border: `1px solid ${TOKENS.border}`, fontSize: 12, fontFamily: FU }}>
                  {mappedCount} of {defs.length} fields matched
                </span>
                {mappedCount === 0 && (
                  <span style={{ fontSize: 12, color: '#f59e0b', fontFamily: FU }}>⚠ No columns matched — check headers against the expected names below.</span>
                )}
              </div>

              {/* Matched columns */}
              {mappedCount > 0 && (
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: TOKENS.textMuted, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 8, fontFamily: FU }}>Column Mapping</div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {defs.map(def => {
                      const hdr = colMap[def.key];
                      if (!hdr) return null;
                      return (
                        <span key={def.key} style={{ padding: '3px 10px', borderRadius: 4, background: TOKENS.bgElevated, border: `1px solid ${TOKENS.border}`, fontSize: 11, fontFamily: FU }}>
                          <span style={{ color: TOKENS.textMuted }}>{hdr}</span>
                          <span style={{ color: TOKENS.textDisabled, margin: '0 4px' }}>→</span>
                          <span style={{ color: TOKENS.gold }}>{def.label}</span>
                        </span>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Unmatched hints */}
              {defs.some(d => !colMap[d.key]) && (
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: TOKENS.textMuted, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4, fontFamily: FU }}>Unmatched fields — rename your columns to any of these:</div>
                  <div style={{ fontSize: 11, color: TOKENS.textDisabled, fontFamily: FU, lineHeight: 1.9 }}>
                    {defs.filter(d => !colMap[d.key]).map(d => (
                      <span key={d.key}>
                        <strong style={{ color: TOKENS.textMuted }}>{d.label}:</strong>{' '}
                        {d.alts.slice(0, 5).join(', ')}{d.alts.length > 5 ? '…' : ''}
                        &nbsp;&nbsp;&nbsp;
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Preview table */}
              <div>
                <div style={{ fontSize: 11, fontWeight: 600, color: TOKENS.textMuted, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 8, fontFamily: FU }}>
                  Data Preview — first {Math.min(5, parsed.rows.length)} of {parsed.rows.length} rows
                </div>
                <div style={{ overflowX: 'auto', border: `1px solid ${TOKENS.border}`, borderRadius: 6 }}>
                  <table style={{ borderCollapse: 'collapse', fontSize: 11, fontFamily: FU, width: '100%' }}>
                    <thead>
                      <tr>
                        {parsed.headers.map((h, i) => {
                          const mappedField = Object.keys(colMap).find(k => colMap[k] === h);
                          const fieldLabel  = mappedField ? defs.find(d => d.key === mappedField)?.label : null;
                          return (
                            <th key={i} style={{ padding: '6px 10px', background: TOKENS.bgElevated, color: fieldLabel ? TOKENS.gold : TOKENS.textMuted, border: `1px solid ${TOKENS.border}`, textAlign: 'left', whiteSpace: 'nowrap', fontWeight: 600 }}>
                              {h}
                              {fieldLabel && <span style={{ color: TOKENS.textDisabled, fontWeight: 400 }}> → {fieldLabel}</span>}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {parsed.rows.slice(0, 5).map((row, i) => (
                        <tr key={i} style={{ background: i % 2 === 0 ? TOKENS.bgCard : TOKENS.bgApp }}>
                          {parsed.headers.map((h, j) => (
                            <td key={j} style={{ padding: '5px 10px', border: `1px solid ${TOKENS.border}`, color: TOKENS.textSecondary, maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {row[h]}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {parsed.rows.length > 5 && (
                  <div style={{ fontSize: 11, color: TOKENS.textDisabled, marginTop: 4, fontFamily: FU }}>…and {parsed.rows.length - 5} more rows</div>
                )}
              </div>
            </>
          ) : (
            !error && (
              <div style={{ textAlign: 'center', padding: '48px 20px', color: TOKENS.textDisabled, fontFamily: FU, fontSize: 13 }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>📊</div>
                <div>Upload a CSV or Excel file to preview and import records.</div>
                <div style={{ marginTop: 8, fontSize: 11 }}>Supported: .csv · .xlsx · .xls — first row must be column headers</div>
              </div>
            )
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: '14px 20px', borderTop: `1px solid ${TOKENS.border}`, display: 'flex', gap: 10, justifyContent: 'flex-end', background: TOKENS.bgApp, flexShrink: 0 }}>
          <button
            onClick={onClose}
            style={{ padding: '8px 18px', borderRadius: 6, border: `1px solid ${TOKENS.border}`, background: 'none', color: TOKENS.textMuted, fontSize: 13, cursor: 'pointer', fontFamily: FU }}
          >
            Cancel
          </button>
          <button
            onClick={doImport}
            disabled={!canImport}
            style={{ padding: '8px 22px', borderRadius: 6, border: 'none', background: canImport ? TOKENS.gold : TOKENS.bgElevated, color: canImport ? '#0A1628' : TOKENS.textDisabled, fontSize: 13, fontWeight: 600, cursor: canImport ? 'pointer' : 'not-allowed', fontFamily: FU }}
          >
            {parsed ? `Import ${parsed.rows.length} Row${parsed.rows.length !== 1 ? 's' : ''}` : 'Import'}
          </button>
        </div>
      </div>
    </div>
  );
}
